import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer>
      <div>
        <h2>Contact us today!</h2>
        <p className="contact-list">
          <Link to="/contact">Free Consultation</Link>
        </p>
        <p> &#169;2023 Blu Egg Dev</p>
      </div>
    </footer>
  );
};

export default Footer;
